const FR = {
    priseRendezVous: 'Prendre rendez-vous',
    priseRendezVousPhrase: 'Réservez une visite privée ou la présentation d’une œuvre à la galerie.',
    demanderPresentation: 'Demander une présentation',
    boutique: 'Boutique',
    acheterEnLigne: 'Acheter en ligne',
    prixTtc: 'TTC',
    allerAuContenu: 'Aller au contenu',
    navigation: 'Navigation principale',
    langue: 'Langue',
    accueil: 'Accueil',
    artistes: 'Artistes',
    expositions: 'Expositions',
    foires: 'Foires',
    oeuvres: 'Œuvres disponibles',
    actualites: 'Actualités',
    laGalerie: 'La galerie',
    contact: 'Contact',
    mentions: 'Mentions légales',
    confidentialite: 'Confidentialité',
    planDuSite: 'Plan du site',
    expositionEnCours: 'Exposition en cours',
    artistesRepresentes: 'Artistes représentés',
    agenda: 'Agenda',
    evenements: 'Prochains événements',
    inscriptionEvenement: 'S’inscrire',
    typesEvenement: {
        vernissage: 'Vernissage',
        visite: 'Visite',
        conference: 'Conférence',
        signature: 'Signature',
        finissage: 'Finissage',
        autre: 'Événement',
    },
    voirTout: 'Voir tout',
    lireLeTexte: 'Lire le texte de l’exposition',
    vernissage: 'Vernissage',
    stand: 'Stand',
    aVenir: 'À venir',
    enCours: 'En cours',
    passees: 'Passées',
    biographie: 'Biographie',
    presse: 'Presse',
    vuesAccrochage: 'Vues d’accrochage',
    oeuvresPresentees: 'Œuvres présentées',
    oeuvre: 'Œuvre',
    technique: 'Technique',
    dimensions: 'Dimensions',
    editionTitre: 'Édition',
    statut: 'Statut',
    prix: 'Prix',
    prixSurDemande: 'Prix sur demande',
    demanderLeDossier: 'Demander le dossier',
    statutDisponible: 'Disponible',
    statutReservee: 'Réservée',
    statutVendue: 'Vendue',
    statutEnDepot: 'En dépôt',
    dimensionsVariables: 'Dimensions variables',
    edition: (exemplaire, tirage) => `Édition ${String(exemplaire)}/${String(tirage)}`,
    editionDe: (tirage) => `Édition de ${String(tirage)}`,
    epreuveArtiste: (tirage) => `Épreuve d’artiste, édition de ${String(tirage)}`,
    epreuvesArtiste: (nombre) => `${String(nombre)} EA`,
    lettreInformation: 'Lettre d’information',
    adresseEmail: 'Adresse e-mail',
    sInscrire: 'S’inscrire',
    nom: 'Nom',
    message: 'Message',
    telephone: 'Téléphone',
    envoyer: 'Envoyer',
    sujet: 'Sujet',
    equipe: 'Équipe',
    horaires: 'Horaires',
    adresse: 'Adresse',
    suivre: 'Suivre',
    plan: 'Voir le plan',
    galerie: 'Galerie',
    propulsePar: 'Site propulsé par Artosera',
    pageIntrouvable: 'Page introuvable',
    pageIntrouvableTexte: 'Cette adresse ne correspond à aucune page du site.',
    retourAccueil: 'Retour à l’accueil',
    fluxRss: 'Flux RSS des actualités',
    aucuneOeuvre: 'Aucune œuvre n’est présentée en ligne pour le moment.',
    aucuneExposition: 'Aucune exposition à cette rubrique pour le moment.',
    aucuneActualite: 'Aucune actualité pour le moment.',
    etSurRendezVous: 'et sur rendez-vous',
    fermer: 'Fermer',
    voirEnGrand: 'Voir en grand',
    jours: ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'],
    mois: [
        'janvier',
        'février',
        'mars',
        'avril',
        'mai',
        'juin',
        'juillet',
        'août',
        'septembre',
        'octobre',
        'novembre',
        'décembre',
    ],
    moisCourts: [
        'janv.',
        'févr.',
        'mars',
        'avr.',
        'mai',
        'juin',
        'juill.',
        'août',
        'sept.',
        'oct.',
        'nov.',
        'déc.',
    ],
    aPropos: (nom) => `${nom} — galerie d’art`,
};
const EN = {
    priseRendezVous: 'Book an appointment',
    priseRendezVousPhrase: 'Book a private visit or an artwork presentation at the gallery.',
    demanderPresentation: 'Request a presentation',
    boutique: 'Shop',
    acheterEnLigne: 'Buy online',
    prixTtc: 'incl. VAT',
    allerAuContenu: 'Skip to content',
    navigation: 'Main navigation',
    langue: 'Language',
    accueil: 'Home',
    artistes: 'Artists',
    expositions: 'Exhibitions',
    foires: 'Fairs',
    oeuvres: 'Available works',
    actualites: 'News',
    laGalerie: 'The gallery',
    contact: 'Contact',
    mentions: 'Legal notice',
    confidentialite: 'Privacy',
    planDuSite: 'Site map',
    expositionEnCours: 'Current exhibition',
    artistesRepresentes: 'Represented artists',
    agenda: 'Calendar',
    evenements: 'Upcoming events',
    inscriptionEvenement: 'Register',
    typesEvenement: {
        vernissage: 'Opening',
        visite: 'Visit',
        conference: 'Talk',
        signature: 'Signing',
        finissage: 'Closing event',
        autre: 'Event',
    },
    voirTout: 'View all',
    lireLeTexte: 'Read the exhibition text',
    vernissage: 'Opening',
    stand: 'Booth',
    aVenir: 'Upcoming',
    enCours: 'Current',
    passees: 'Past',
    biographie: 'Biography',
    presse: 'Press',
    vuesAccrochage: 'Installation views',
    oeuvresPresentees: 'Works on view',
    oeuvre: 'Work',
    technique: 'Medium',
    dimensions: 'Dimensions',
    editionTitre: 'Edition',
    statut: 'Status',
    prix: 'Price',
    prixSurDemande: 'Price on request',
    demanderLeDossier: 'Request the file',
    statutDisponible: 'Available',
    statutReservee: 'Reserved',
    statutVendue: 'Sold',
    statutEnDepot: 'On consignment',
    dimensionsVariables: 'Variable dimensions',
    edition: (exemplaire, tirage) => `Edition ${String(exemplaire)}/${String(tirage)}`,
    editionDe: (tirage) => `Edition of ${String(tirage)}`,
    epreuveArtiste: (tirage) => `Artist’s proof, edition of ${String(tirage)}`,
    epreuvesArtiste: (nombre) => `${String(nombre)} AP`,
    lettreInformation: 'Newsletter',
    adresseEmail: 'Email address',
    sInscrire: 'Subscribe',
    nom: 'Name',
    message: 'Message',
    telephone: 'Phone',
    envoyer: 'Send',
    sujet: 'Subject',
    equipe: 'Team',
    horaires: 'Opening hours',
    adresse: 'Address',
    suivre: 'Follow',
    plan: 'View the map',
    galerie: 'Gallery',
    propulsePar: 'Website powered by Artosera',
    pageIntrouvable: 'Page not found',
    pageIntrouvableTexte: 'This address matches no page on the site.',
    retourAccueil: 'Back to home',
    fluxRss: 'News RSS feed',
    aucuneOeuvre: 'No work is shown online at the moment.',
    aucuneExposition: 'Nothing in this section at the moment.',
    aucuneActualite: 'No news at the moment.',
    etSurRendezVous: 'and by appointment',
    fermer: 'Close',
    voirEnGrand: 'View larger',
    jours: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    mois: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ],
    moisCourts: [
        'Jan.',
        'Feb.',
        'Mar.',
        'Apr.',
        'May',
        'June',
        'July',
        'Aug.',
        'Sept.',
        'Oct.',
        'Nov.',
        'Dec.',
    ],
    aPropos: (nom) => `${nom} — art gallery`,
};
const TABLE = { fr: FR, en: EN };
export function libelles(langue) {
    return TABLE[langue];
}
//# sourceMappingURL=i18n.js.map